
import { AudioAds } from '../AudioAds';

export class AudioAdsPartner extends AudioAds {

  constructor(props) {
    super(props, { pageForOrgType: 'PARTNER' })
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/AudioAdsPartner.js